module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_progress_done_new.7858bec7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_progress_done_new.png
// module id = 3008
// module chunks = 11